<template>
    <div class="page">
        <task-header @reload="reloadList" />

        <div class="content bg-white border">
            <div class="row">
                <div
                    class="col-md-8 pr-md-0"
                    :class="{
                        'd-none d-md-block': viewTask
                    }"
                >
                    <task-list ref="taskList" />
                </div>
                <div class="col-md-4 pl-md-0 border-left">
                    <task-details v-if="viewTask != null" />
                    <div v-else class="no-task d-none d-md-block">
                        <div><i class="fas fa-sticky-note"></i></div>
                        <div>No task selected</div>
                        <div class="text-dark">
                            Select a task to view the details
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TaskList from "@/components/task-view/task-list.vue";
import TaskHeader from "@/components/task-view/task-header.vue";
import TaskDetails from "@/components/task-view/task-details.vue";

export default {
    components: { TaskHeader, TaskList, TaskDetails },
    data() {
        return {
            settingsLoaded: false
        };
    },
    mounted() {
        this.$store.commit("task/unSetSelectedTask");
    },
    computed: {
        viewTask() {
            return this.$store.getters["task/selected"];
        }
    },
    methods: {
        reloadList() {
            // trigger reload
            this.$refs.taskList.clearRefresh();
        }
    }
};
</script>
<style type="text/css">
.no-task {
    margin: 1.5rem;
    padding-top: 20%;
    color: #d6d5d5;
    text-align: center;
}

.no-task .fas {
    font-size: 8em;
}
</style>
